import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from "react-i18next";

import {
  Button,
  Dropdown,
  Alert,
} from '@lockerpm/design';

import {
  CaretDownOutlined
} from "@ant-design/icons";

import ImageIcon from "../../../../../web-sh/src/components/items/ImageIcon";

import global from "../../../../../config/global";
import common from "../../../../../utils/common";

const Filter = (props) => {
  const { t } = useTranslation()
  const {
    className = '',
    params = {},
    loading = false,
    isFreePlan = false,
    isEnterpriseMember = false,
    setParams = () => { }
  } = props;

  const locale = useSelector((state) => state.system.locale);
  const isMobile = useSelector((state) => state.system.isMobile);

  const sortOptions = global.constants.SORT_OPTIONS.filter((o) => o.orderField !== 'name')

  const selectedSortOption = useMemo(() => {
    return sortOptions.find((o) =>
      o.orderDirection === params.orderDirection
    )
  }, [params])

  const sortMenus = useMemo(() => {
    return sortOptions.map((o) => ({
      key: o.key,
      label: <p className={o.key === selectedSortOption?.key ? 'text-primary' : ''}>
        {t(o.label)}
      </p>,
      onClick: () => setParams({
        ...params,
        orderDirection: o.orderDirection
      })
    }))
  }, [selectedSortOption, params, locale])

  return (
    <div
      className={`filter ${className}`}
    >
      {
        isFreePlan && !isEnterpriseMember && <Alert
          className="py-1 mb-2 w-auto lg:w-max"
          message={
            <Trans
              i18nKey={'password_history.note'}
              components={{
                span: <span
                  className="ml-1 text-primary cursor-pointer font-semibold"
                  onClick={() => common.clickBuyPremium()}
                />
              }}
            />
          }
          type="warning"
          closable={false}
        />
      }
      <div
        className="flex items-center justify-end"
      >
        {
          isMobile ? <Dropdown
            trigger={['click']}
            disabled={loading}
            menu={{
              items: sortMenus,
              selectedKeys: []
            }}
          >
            <Button
              shape="circle"
              icon={<ImageIcon
                name={'sort'}
                width={18}
                height={18}
              />}
            />
          </Dropdown> : <Dropdown.Button
            className="w-auto"
            icon={<CaretDownOutlined />}
            trigger={['click']}
            disabled={loading}
            menu={{
              items: sortMenus,
              selectedKeys: []
            }}
          >
            {t('sort_options.sort_by')}
          </Dropdown.Button>
        }
      </div>
    </div>
  );
}

export default Filter;
